import { Pipe, PipeTransform } from '@angular/core'
import { ApiConnectionActivityTypes } from '@tv3/store/connection/connection.model'

@Pipe({
  name: 'connectionActivityType',
})
export class ConnectionActivityTypePipe implements PipeTransform {
  transform(type: ApiConnectionActivityTypes) {
    let typeText = `${type}`
    switch (type) {
      case ApiConnectionActivityTypes.AvailabilityPull:
        typeText = $localize`Availability Pull`
        break
      case ApiConnectionActivityTypes.AvailabilityPush:
        typeText = $localize`Availability Push`
        break
      case ApiConnectionActivityTypes.RatesPush:
        typeText = $localize`Rate Push`
        break
      case ApiConnectionActivityTypes.ListingPush:
        typeText = $localize`Listing Push`
        break
    }
    return typeText
  }
}
